import React from "react";
import { Paper } from "@mui/material";
import { MainPageContainer } from "pymble-ui/components";
import PastoralGrid from "../components/pastoral/PastoralGrid";
import "./Dashboard.css";

const Dashboard: React.FC = () => {
	return (
		<MainPageContainer cssClass="pa-dashboard">
			<Paper className="pa-content-card" elevation={0}>
				<PastoralGrid />
			</Paper>
		</MainPageContainer>
	);
};

export default Dashboard;
